import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  Boxes,
  ShoppingCart,
  Wrench,
  WalletCards,
  Clipboard,
  User,
  Activity,
  LogOut,
  Truck, 
  Users,
  X,
  BadgeDollarSign,
  HandCoins,
} from "lucide-react";

const Sidebar = ({
  setActivePage,
  permissions = [],
  isOpen = false,
  onClose,
}) => {
  const { pathname } = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.role === "admin";

  /* =====================================================
     ADMIN MENU
  ===================================================== */

  const adminMenu = [
    {
      path: "/admin/dashboard",
      label: "Dashboardi",
      icon: <LayoutDashboard size={21} />,
    },
    {
      path: "/admin/products",
      label: "Katalogu i Web",
      icon: <Package size={21} />,
    },
     {
      path: "/admin/suppliers",
      label: "Furnitorët",
      icon: <Truck size={21} />,
    },

        {
      path: "/admin/customers",
      label: "Klientët",
      icon: <Users size={21} />,
    },

    {
      path: "/admin/device-purchases",
      label: "Blerje Pajisjesh",
      icon: <BadgeDollarSign size={21} />,
    },
    {
      path: "/admin/expenses",
      label: "Shpenzimet e dyqanit",
      icon: <WalletCards size={21} />,
    },
       {
      path: "/admin/payroll",
      label: "Rrogat",
      icon: <HandCoins size={21} />,
    },
    {
      path: "/admin/parts",
      label: "Pjesët",
      icon: <Boxes size={21} />,
    },
    {
      path: "/admin/orders",
      label: "Shitje nga Web",
      icon: <Clipboard size={21} />,
    },
    {
      path: "/admin/sales",
      label: "Shitje",
      icon: <ShoppingCart size={21} />,
    },
    {
      path: "/admin/repairs",
      label: "Riparime",
      icon: <Wrench size={21} />,
    },
    {
      path: "/admin/analysis",
      label: "Analiza",
      icon: <Activity size={21} />,
    },
    {
      path: "/admin/settings",
      label: "Konfigurime",
      icon: <User size={21} />,
    },
  ];

  /* =====================================================
     USER MENU
  ===================================================== */

  const userMenu = [
    {
      page: "dashboard",
      label: "Dashboardi",
      icon: <LayoutDashboard size={21} />,
    },
    {
      page: "products",
      label: "Produkte",
      icon: <Package size={21} />,
    },

     {
      page: "suppliers",
      label: "Furnitorët",
       icon: <Truck size={21} />,
    },
     {
      page: "customers",
      label: "Klientët",
     icon: <Users size={21} />,
    },

     {
      page: "device-purchases",
      label: "Blerje Pajisjesh",
       icon: <BadgeDollarSign size={21} />,
    },
    {
      page: "parts",
      label: "Pjesë",
      icon: <Boxes size={21} />,
    },
    {
      page: "repairs",
      label: "Riparime",
      icon: <Wrench size={21} />,
    },
      {
      page: "expenses",
      label: "Shpenzimet e dyqanit",
       icon: <WalletCards size={21}  />,
    },
    {
      page: "sales",
      label: "Shitje",
      icon: <ShoppingCart size={21} />,
    },
    {
      page: "orders",
      label: "Porosi",
      icon: <Clipboard size={21} />,
    },
    {
      page: "settings",
      label: "Konfigurime",
      icon: <User size={21} />,
    },
  ];

  const allowedUserMenu = userMenu.filter(
    (item) =>
      item.page === "dashboard" ||
      permissions.includes(item.page)
  );

  /* =====================================================
     HANDLERS
  ===================================================== */

  const handleUserPage = (page) => {
    setActivePage?.(page);
    onClose?.();
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  /* =====================================================
     UI
  ===================================================== */

  return (
    <>
      {/* OVERLAY MOBILE */}
      <div
        onClick={onClose}
        className={`
          fixed inset-0 z-40
          bg-black/50 backdrop-blur-sm
          transition-opacity duration-300
          lg:hidden

          ${
            isOpen
              ? "pointer-events-auto opacity-100"
              : "pointer-events-none opacity-0"
          }
        `}
      />

      {/* SIDEBAR */}
      <aside
        className={`
          fixed left-0 top-0 z-50
          flex h-screen w-64 flex-col

          bg-gradient-to-b
          from-blue-700
          to-blue-950

          text-white
          shadow-2xl

          transition-transform
          duration-300
          ease-in-out

          ${
            isOpen
              ? "translate-x-0"
              : "-translate-x-full"
          }

          lg:translate-x-0
        `}
      >
        {/* =====================================================
            HEADER
        ===================================================== */}

        <div
          className="
            flex min-h-16
            items-center
            justify-between

            border-b
            border-white/15

            px-5
          "
        >
          <div>
            <h2 className="font-bold">
              {isAdmin
                ? "Admin Panel"
                : "User Panel"}
            </h2>

            <p className="mt-0.5 text-xs text-blue-200">
              MasterPhone
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="
              flex h-9 w-9
              items-center
              justify-center

              rounded-lg
              bg-white/10

              transition
              hover:bg-white/20

              lg:hidden
            "
            aria-label="Mbyll menunë"
          >
            <X size={21} />
          </button>
        </div>

        {/* =====================================================
            USER INFO
        ===================================================== */}

        <div
          className="
            border-b
            border-white/10
            px-5
            py-4
          "
        >
          <p className="text-xs text-blue-200/70">
            I identifikuar si
          </p>

          <p className="mt-1 truncate text-sm font-semibold">
            {user?.username || "Përdorues"}
          </p>
        </div>

        {/* =====================================================
            NAVIGATION
        ===================================================== */}

        <nav
          className="
            flex-1
            space-y-1
            overflow-y-auto
            px-3
            py-4
          "
        >
          {/* ADMIN */}

          {isAdmin &&
            adminMenu.map((item) => {
              const isActive =
                pathname === item.path;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={onClose}
                  className={`
                    flex
                    items-center
                    gap-3

                    rounded-xl
                    px-4
                    py-3

                    text-sm
                    font-medium

                    transition-all
                    duration-200

                    ${
                      isActive
                        ? "bg-white text-blue-700 shadow-md"
                        : "text-blue-50 hover:bg-white/10"
                    }
                  `}
                >
                  {item.icon}

                  <span>
                    {item.label}
                  </span>
                </Link>
              );
            })}

          {/* USER */}

          {!isAdmin &&
            allowedUserMenu.map((item) => (
              <button
                key={item.page}
                type="button"
                onClick={() =>
                  handleUserPage(item.page)
                }
                className="
                  flex
                  w-full
                  items-center
                  gap-3

                  rounded-xl
                  px-4
                  py-3

                  text-left
                  text-sm
                  font-medium

                  text-blue-50

                  transition-all
                  duration-200

                  hover:bg-white/10
                "
              >
                {item.icon}

                <span>
                  {item.label}
                </span>
              </button>
            ))}
        </nav>

        {/* =====================================================
            LOGOUT
        ===================================================== */}

        <div
          className="
            border-t
            border-white/15
            p-3
          "
        >
          <button
            type="button"
            onClick={handleLogout}
            className="
              flex
              w-full
              items-center
              gap-3

              rounded-xl
              px-4
              py-3

              text-sm
              font-medium

              text-blue-50

              transition

              hover:bg-red-500/20
            "
          >
            <LogOut size={19} />

            <span>
              Dil
            </span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;